/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Electrical_Engineering21Inputs */

const en_job_form_enum_electrical_engineering21 = /** @type {(inputs: Job_Form_Enum_Electrical_Engineering21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Electrical Engineering`)
};

const de_job_form_enum_electrical_engineering21 = /** @type {(inputs: Job_Form_Enum_Electrical_Engineering21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elektrotechnik`)
};

/**
* | output |
* | --- |
* | "Electrical Engineering" |
*
* @param {Job_Form_Enum_Electrical_Engineering21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_electrical_engineering21 = /** @type {((inputs?: Job_Form_Enum_Electrical_Engineering21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Electrical_Engineering21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_electrical_engineering21(inputs)
	return en_job_form_enum_electrical_engineering21(inputs)
});
export { job_form_enum_electrical_engineering21 as "job_form_enum_ELECTRICAL_ENGINEERING" }